export default "__VITE_ASSET__BXybtoYG__"